/**
 * Pattern object for an email address.
 *
 * This pattern should be passed on the rules object to a form field.
 */
export const emailPattern = {
    value: /^([\w+-]\.?)+@[a-z\d-]+(\.[a-z\d-]+)*\.[a-z]+$/i,
    message: 'Invalid email address'
};
